(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thelone-results"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('thelone-results')) {
    customElements.define('thelone-results', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (!this.isConnected) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const rail = this.querySelector('.thelone-results__rail');
        rail.querySelectorAll('[data-results-clone]').forEach(card => card.remove());
        const cards = [...rail.querySelectorAll('.thelone-result')];
        if (cards.length < 2) return;
        const clones = [...cards, ...cards].map(card => {
          const clone = card.cloneNode(true);
          clone.dataset.resultsClone = '';
          clone.setAttribute('aria-hidden', 'true');
          clone.inert = true;
          clone.removeAttribute('data-shopify-editor-block');
          clone.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
          rail.append(clone);
          return clone;
        });
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        let hovered = false;
        let touching = false;
        let visible = false;
        let positions = [];
        let index = 0;
        const stop = () => clearInterval(this.timer);
        const start = () => {
          stop();
          if (motion.matches || hovered || touching || !visible || document.hidden || this.contains(document.activeElement) || positions.length < 2) return;
          this.timer = setInterval(() => show(index + 1), Number(this.dataset.autoplayDelay) || 5000);
        };
        const show = (next) => {
          index = (next + positions.length) % positions.length;
          rail.scrollTo({ left: positions[index], behavior: motion.matches ? 'instant' : 'smooth' });
        };
        const sync = () => {
          index = positions.reduce((best, left, i) => Math.abs(left - rail.scrollLeft) < Math.abs(positions[best] - rail.scrollLeft) ? i : best, 0);
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => {
            const loopWidth = positions[cards.length];
            if (loopWidth > 0 && rail.scrollLeft >= loopWidth - 1) {
              rail.scrollTo({ left: Math.max(0, rail.scrollLeft - loopWidth), behavior: 'instant' });
              index = 0;
            }
          }, 150);
        };
        const measure = () => {
          const origin = cards[0].offsetLeft;
          positions = [...cards, clones[0]].map(card => card.offsetLeft - origin);
          sync();
          start();
        };
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; stop(); } }, { signal });
        this.addEventListener('pointerleave', () => { hovered = false; start(); }, { signal });
        this.addEventListener('pointerdown', () => { touching = true; stop(); }, { signal });
        window.addEventListener('pointerup', () => { touching = false; start(); }, { signal });
        window.addEventListener('pointercancel', () => { touching = false; start(); }, { signal });
        this.addEventListener('focusin', stop, { signal });
        this.addEventListener('focusout', () => queueMicrotask(start), { signal });
        rail.addEventListener('scroll', sync, { passive: true, signal });
        rail.addEventListener('keydown', event => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          show(index + (event.key === 'ArrowRight' ? 1 : -1));
        }, { signal });
        motion.addEventListener('change', start, { signal });
        document.addEventListener('visibilitychange', start, { signal });
        this.resizeObserver = new ResizeObserver(measure);
        this.resizeObserver.observe(rail);
        this.visibilityObserver = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; start(); });
        this.visibilityObserver.observe(this);
        measure();
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.settleTimer);
        clearInterval(this.timer);
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
